import { api } from "./base.api.ts"

export const addExternalReview = async (review) => {
  await api.post("external-review", review)
}
